// extracted by mini-css-extract-plugin
export default {"cls1":"ConfirmationModal-cls1_d8_","cls2":"ConfirmationModal-cls2__UZ ConfirmationModal-cls1_d8_"};